export const ParseJenisKelaminSurat = (jenis_kelamin) =>  jenis_kelamin === 1 ? 'Laki-laki' : 'Perempuan' 